/**
 * Created by RaoMeng on 2018/11/7
 * Desc: 通讯录首页
 */

import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.min.css'
import 'css/phones.css'
import {List, Icon, Skeleton, message} from 'antd'
import PhonesItem from "components/PhonesItem";
import PhonesBean from 'model/PhonesBean'
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {_baseURL, API} from "../../configs/api.config";
import {Toast} from "antd-mobile";
import RefreshLayout from "../../components/RefreshLayout";
import {getStrValue} from "../../utils/common";
import {connect} from 'react-redux'
import {saveListState} from "../../redux/actions/listState";

let mySwiper

const mPageSize = 10
let mPageIndex = 0

class PhonesSelect extends Component {

    constructor() {
        super()

        this.state = {
            selectIndex: 0,
            teacherList: [],
            parentList: [],
            isPhonesLoading: true,
            isClassLoading: true,
            isRefreshing: false,
            height: document.documentElement.clientHeight,
        }
    }

    componentDidMount() {
        document.title = '通讯录'
        const hei = this.state.height - ReactDOM.findDOMNode(this.contain1).offsetTop
            - ReactDOM.findDOMNode(this.contain2).offsetTop;
        this.setState({
            height: hei
        })
        const that = this
        const {selectIndex} = this.state

        mySwiper = new Swiper('.swiper-container', {
            autoplay: false,
            loop: false,
            on: {
                slideChangeTransitionEnd: function () {
                    that.setState({
                        selectIndex: this.activeIndex
                    })
                }
            }
        })

        if (this.props.listState.tabIndex >= 0) {
            this.setState({
                selectIndex: this.props.listState.tabIndex
            }, () => {
                mySwiper.slideTo(this.state.selectIndex, 0, false)
            })
        }

        mPageIndex = 0
        this.getTeacherPhones()
        this.getClassList()
    }

    render() {
        const {
            selectIndex, teacherList, parentList
            , isPhonesLoading, isClassLoading, isRefreshing, height
        } = this.state

        const teacherItems1 =
            <Skeleton loading={isPhonesLoading} active paragraph={{rows: 3}}>
                <List dataSource={teacherList} renderItem={
                    (item, index) => (
                        <List.Item>
                            <div className='phoneListItem'
                                 onClick={this.onTeacherItemClick.bind(this, index)}>
                                <div
                                    className='phoneItemText'>{item.withSchool}</div>
                                <Icon type="right" theme="outlined"/>
                            </div>
                        </List.Item>
                    )}/>
            </Skeleton>

        const teacherItems =
            <RefreshLayout
                refreshing={isRefreshing}
                onRefresh={this.getTeacherPhones}
                height={height}>
                <Skeleton loading={isPhonesLoading} active paragraph={{rows: 3}}>
                    <List className='phones-list-layout' dataSource={teacherList}
                          renderItem={phonesBean => (
                              <List.Item>
                                  <PhonesItem phonesBean={phonesBean}/>
                              </List.Item>
                          )}/>
                </Skeleton>
            </RefreshLayout>

        const parentItems = <Skeleton loading={isClassLoading} active paragraph={{rows: 3}}>
            <List dataSource={parentList} renderItem={
                (item, index) => (
                    <List.Item>
                        <div className='phoneListItem'
                             onClick={this.onParentItemClick.bind(this, index)}>
                            <div
                                className='phoneItemText'>{item.gradeName + item.clazzName}</div>
                            <Icon type="right" theme="outlined"/>
                        </div>
                    </List.Item>
                )}/>
        </Skeleton>

        return (
            <div className='phone-select-root'>
                <div className='gray-line'></div>
                <div className='identity-select'>
                    <div style={{fontSize:15}} className={selectIndex == 0 ?
                        'identity-item-select' : 'identity-item-normal'}
                         onClick={this.onTeacherClick}>老师
                    </div>
                    <div className={selectIndex == 1 ?
                        'identity-item-select' : 'identity-item-normal'}
                         onClick={this.onParentClick}>家长
                    </div>
                </div>
                <div className="swiper-container"
                     ref={el => {
                         this.contain1 = el
                     }}>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className='search-bar-root'>
                                <div className='search-bar-layout' onClick={this.toSearchPage.bind(this, 1)}>
                                    <Icon type="search"/>
                                    <span style={{paddingLeft: '10px'}}>搜索联系人</span>
                                </div>
                            </div>
                            <div className='swiper-content'
                                 ref={el => {
                                     this.contain2 = el
                                 }}>
                                {this.props.userInfo.user.schoolId === 7?teacherItems1:teacherItems}
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className='search-bar-root'>
                                <div className='search-bar-layout' onClick={this.toSearchPage.bind(this, 2)}>
                                    <Icon type="search"/>
                                    <span style={{paddingLeft: '10px'}}>搜索联系人</span>
                                </div>
                            </div>
                            <div className='swiper-content'>
                                {parentItems}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    toSearchPage = (role) => {
        if (role === 1) {
            this.props.history.push('/phonesSearch/teacher')
        } else if (role === 2) {
            this.props.history.push('/phonesSearch/parent')
        }
    }

    getClassList = () => {
        const {parentList} = this.state

        let userRole = this.props.userInfo.userRole;
        let params, url
        if (userRole == 1) {
            url = API.GET_STU_CLASS_LIST
            params = {
                stuId: this.props.userInfo.user.student.stuId
            }
        }
        fetchGet(url, params).then(response => {
            Toast.hide();

            if (response && response.data) {
                response.data.map((item, index) => {
                    parentList.push(item)
                })

                this.setState({
                    parentList,
                    isClassLoading: false
                })
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                message.error(error)
            }

            this.setState({
                isClassLoading: false
            })
        })
    }

    getTeacherPhones = () => {
        mPageIndex++
        console.log(mPageIndex)
        try {
            this.setState({
                isRefreshing: true
            })
        } catch (e) {

        }

        const {teacherList} = this.state
        if (mPageIndex === 1) {
            teacherList.length = 0
        }

        fetchPost(API.TEACHER_PHONES_LISTS, {
            teacherId: this.props.userInfo.user.userFunId,
            selectKey: '',
            pageIndex: mPageIndex,
            pageSize: mPageSize
        }).then(response => {
            Toast.hide();

            if (response && response.data && response.data.length > 0) {
                response.data.map((item, index) => {
                    let phoneBean = new PhonesBean()
                    phoneBean.icon = require('imgs/ic_head' + (index % 15 + 1) + '.png')
                    phoneBean.icon = getStrValue(item, 'teacherPhoto')
                    phoneBean.name = getStrValue(item, 'teacherName')
                    phoneBean.phone = [getStrValue(item, 'userPhone')]
                    // phoneBean.claName = getStrValue(item, 'schName')
                    phoneBean.children = [getStrValue(item, 'schoolNameDept')]
                    phoneBean.withSchool = [getStrValue(item, 'teacherWithSchool')]
                    phoneBean.schoolName = [getStrValue(item, 'schoolName')]
                    phoneBean.teacherLists = [getStrValue(item, 'teacherList')]

                    teacherList.push(phoneBean)
                })
            } else {
                if (mPageIndex > 1) {
                    mPageIndex--
                }
            }

            this.setState({
                teacherList,
                isPhonesLoading: false,
                isRefreshing: false,
            })

        }).catch(error => {
            Toast.hide();

            if (mPageIndex > 1) {
                mPageIndex--
            }
            this.setState({
                isRefreshing: false,
                isPhonesLoading: false,
            })
            if (typeof error === 'string') {
                message.error(error)
            }
        })
    }

    onParentItemClick = (index) => {
        const {parentList} = this.state
        let selectItem = parentList[index]
        this.props.history.push('/phonesList/teacher/' + selectItem.clazzId + '/' + selectItem.gradeName + selectItem.clazzName)
    }
    onTeacherItemClick = (index) => {
        const {teacherList} = this.state
        let selectItem = teacherList[index]
        this.props.history.push('/phonesList/parent/' + selectItem.withSchool)
    }
    onTeacherClick = () => {
        this.setState({
            selectIndex: 0
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false)

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    }

    onParentClick = () => {
        this.setState({
            selectIndex: 1
        }, () => {
            mySwiper.slideTo(this.state.selectIndex, 300, false)

            saveListState({
                tabIndex: this.state.selectIndex,
            })()
        })
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PhonesSelect)